export type StatusTone = "live" | "wait" | "doubt";

export const navLinks = [
  { label: "实时进展", href: "#progress" },
  { label: "焦点档案", href: "#follow" },
  { label: "跟进速览", href: "#briefing" },
  { label: "追更标准", href: "#method" },
  { label: "常见问题", href: "#faq" },
];

export const tickerItems = [
  "「蓝海」咖啡翻红线更新：第二批门店名单流出，供应链或迎扩产",
  "《热土之上》续季剧本立项被曝，主角人选仍存变数",
  "老码头夜市改造档口过半，摊主回归意向调查开启",
  "主播「一口甜」停更第 7 天，官方仍无回应",
  "万元「口袋主机」首发渠道补货，二手价差收窄",
  "全国街球巡回赛预热，首个承办城市官宣在即",
  "海滨民宿改造样本观察：改造后流量能否兑现",
  "助农直播间切片维权，平台介入细则被追问",
];

export const heroStats = [
  { value: "40+", label: "正在实时跟进中的线索" },
  { value: "120+", label: "轮持续更新的进展" },
  { value: "3,800+", label: "条留痕的时间戳记录" },
];

export interface Milestone {
  date: string;
  tag: string;
  tone: StatusTone;
  title: string;
  desc: string;
}

export const milestones: Milestone[] = [
  { date: "08-24", tag: "起点", tone: "wait", title: "门店排队被拍到，舆情开始升温", desc: "「蓝海」某门店大排长队的实拍画面流出，评论区讨论度快速上涨。" },
  { date: "08-26", tag: "核实", tone: "live", title: "客流、菜单与点评数据交叉复核", desc: "对比多家平台的排队时长、客单价与口碑走向，确认翻红非单一偶发。" },
  { date: "08-29", tag: "发酵", tone: "live", title: "加盟咨询量被曝激增", desc: "渠道端反馈加盟咨询量明显走高，供应链备货出现紧张信号。" },
  { date: "09-02", tag: "转折", tone: "wait", title: "官方回应装修升级", desc: "品牌方回应以门店升级为主，暂未透露加盟具体节奏。" },
  { date: "09-04", tag: "跟进", tone: "live", title: "第二批翻红门店名单流出", desc: "更多城市门店出现类似客流，名单持续整理中。" },
  { date: "09-05", tag: "今日", tone: "doubt", title: "实探最新门店现场", desc: "实地探访最新翻红门店，进展内容正在整理中。" },
];

export interface ThreadCard {
  id: number;
  channel: string;
  days: string;
  status: string;
  tone: StatusTone;
  img: string;
  title: string;
  excerpt: string;
  updated: string;
}

export const threadCards: ThreadCard[] = [
  {
    id: 1,
    channel: "影视",
    days: "跟了 21 天",
    status: "跟进中",
    tone: "live",
    img: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20movie%20set%20with%20camera%20and%20director%20chair%20warm%20cream%20and%20umber%20tones%20documentary%20photography%20soft%20cinematic%20light%20high%20detail&width=900&height=600&seq=51eat-follow-01&orientation=landscape",
    title: "《热土之上》续季开发线：立项、选角与排期的新信号",
    excerpt: "剧本立项被曝、主演人选传出变化、拍摄档期说法不一，多条信号等待对齐。",
    updated: "09-05 10:20",
  },
  {
    id: 2,
    channel: "城市",
    days: "跟了 14 天",
    status: "跟进中",
    tone: "live",
    img: "https://readdy.ai/api/search-image?query=night%20market%20food%20stalls%20with%20warm%20string%20lights%20people%20strolling%20documentary%20street%20photography%20golden%20and%20orange%20tones%20cozy%20evening%20atmosphere&width=900&height=600&seq=51eat-follow-02&orientation=landscape",
    title: "老码头夜市改造观察线：摊主回归与客流兑现",
    excerpt: "档口过半完成改造，摊主回归意向调查开启，改造后的客流能否兑现成下一焦点。",
    updated: "09-05 08:15",
  },
  {
    id: 3,
    channel: "科技",
    days: "跟了 8 天",
    status: "待更新",
    tone: "wait",
    img: "https://readdy.ai/api/search-image?query=compact%20mini%20desktop%20computer%20tower%20on%20a%20clean%20warm%20cream%20studio%20background%20soft%20shadow%20minimal%20tech%20product%20photography%20high%20detail&width=900&height=600&seq=51eat-follow-03&orientation=landscape",
    title: "「口袋主机」价格战线：定价、首发与补货节奏",
    excerpt: "首发渠道开始补货，二手价差收窄，定价策略是否松动仍在观察。",
    updated: "09-04 23:50",
  },
  {
    id: 4,
    channel: "直播",
    days: "跟了 7 天",
    status: "存疑",
    tone: "doubt",
    img: "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20desk%20with%20microphone%20and%20monitor%20screens%20warm%20cream%20tones%20documentary%20soft%20light%20high%20detail&width=900&height=600&seq=51eat-follow-04&orientation=landscape",
    title: "主播「一口甜」停更线：官方迟迟未回应的第 7 天",
    excerpt: "停更原因说法不一，评论区仍未出现官方说明，处于存疑跟进阶段。",
    updated: "09-04 21:30",
  },
];

export const channels = ["全部", "影视", "商业", "城市", "科技", "直播", "舆情", "文旅"];

export interface BriefItem {
  id: number;
  channel: string;
  title: string;
  status: string;
  tone: StatusTone;
  time: string;
}

export const briefing: BriefItem[] = [
  { id: 1, channel: "影视", title: "《热土之上》续季剧本立项被曝，主角人选仍存变数", status: "跟进中", tone: "live", time: "09-05 10:20" },
  { id: 2, channel: "商业", title: "「蓝海」咖啡第二批翻红门店名单流出，供应链或迎扩产", status: "跟进中", tone: "live", time: "09-05 09:40" },
  { id: 3, channel: "城市", title: "老码头夜市改造档口过半，摊主回归意向调查开启", status: "跟进中", tone: "live", time: "09-05 08:15" },
  { id: 4, channel: "科技", title: "万元「口袋主机」首发渠道补货，二手价差收窄", status: "待更新", tone: "wait", time: "09-04 23:50" },
  { id: 5, channel: "直播", title: "主播「一口甜」停更第 7 天，评论区仍未见官方说明", status: "存疑", tone: "doubt", time: "09-04 21:30" },
  { id: 6, channel: "体育", title: "全国街球巡回赛预热，首个承办城市官宣在即", status: "跟进中", tone: "live", time: "09-04 19:10" },
  { id: 7, channel: "文旅", title: "海滨民宿改造样本观察：改造后的流量是否兑现", status: "跟进中", tone: "live", time: "09-04 17:45" },
  { id: 8, channel: "直播", title: "助农直播间切片维权，平台介入细则被追问", status: "跟进中", tone: "live", time: "09-04 16:20" },
  { id: 9, channel: "商业", title: "连锁茶饮「茶里寻」出海首站落地，门店目标披露", status: "待更新", tone: "wait", time: "09-04 14:05" },
  { id: 10, channel: "影视", title: "大制作漫改剧杀青物料曝出，定档传闻升温", status: "跟进中", tone: "live", time: "09-04 12:40" },
  { id: 11, channel: "舆情", title: "本地「网红市集」热度回落，商家续约意愿成焦点", status: "跟进中", tone: "live", time: "09-04 11:00" },
  { id: 12, channel: "城市", title: "老旧小区加梯工程进度线，两处样板楼进入验收", status: "跟进中", tone: "live", time: "09-04 09:25" },
];

export const faqs = [
  {
    q: "51吃料到底在“跟”什么？",
    a: "我们聚焦有后续发展空间的线索——无论是影视制作、商业变动、城市改造还是公共讨论，只要它在继续向前，51吃料就会把它做成一条可回看的进展档案，持续更新到尘埃落定。",
  },
  {
    q: "“最新进展”和普通爆料有什么区别？",
    a: "爆料往往只给一个点，我们记录的是线。每一条最新进展都会标注更新时间与依据口径，把发生了什么、谁回应的、还有哪些待确认讲清楚，而不是停留在情绪化转述。",
  },
  {
    q: "为什么有时一条线好几天没有动静？",
    a: "更新只建立在有实际进展的前提下。没有新的可核验信息时，我们会明确标注「待更新」而不是硬凑内容，保证你看到的是实时跟进的有效信号。",
  },
  {
    q: "遇到各方说法矛盾时会怎么处理？",
    a: "口径对不上的内容会被标记为「存疑」，我们不会轻易替某一边下结论，而是把分歧点摆出来、持续跟到官方或更多来源给出答案。",
  },
  {
    q: "想最快找到某条线索的后续，该怎么做？",
    a: "可以用频道分类定位题材，再按更新时间倒序找最新动态；焦点档案区则集中呈现当前仍在追踪、且具有后续价值的长线。",
  },
  {
    q: "如果发现记录有误，会纠正吗？",
    a: "会。任何一处被证实的偏差，我们都会在原文中更正并标注修订时间，保持进展档案的透明与可追溯。",
  },
];

export const principles = [
  { no: "01", title: "交叉核验", desc: "至少两个独立信息源对齐后，进展才被记录进档案。" },
  { no: "02", title: "时间线留痕", desc: "每轮持续更新都带时间戳，谁先谁后一目了然。" },
  { no: "03", title: "存疑先标", desc: "说法矛盾就标「存疑」，不急着替任一方定性。" },
  { no: "04", title: "有信才更", desc: "线索未完，档案不关；没有新进展就明确告知待更新。" },
];